import { render } from "./MonogramEditor.vue?vue&type=template&id=27907e11&scoped=true"
import script from "./MonogramEditor.vue?vue&type=script&lang=js"
export * from "./MonogramEditor.vue?vue&type=script&lang=js"

import "./MonogramEditor.vue?vue&type=style&index=0&id=27907e11&scoped=true&lang=css"
import "./MonogramEditor.vue?vue&type=style&index=1&id=27907e11&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27907e11"]])

export default __exports__